module.exports = __webpack_public_path__ + "img/cm.a72fdb01.svg";